"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sx = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const AccountBalance_1 = tslib_1.__importDefault(require("@mui/icons-material/AccountBalance"));
const ArrowDropDown_1 = tslib_1.__importDefault(require("@mui/icons-material/ArrowDropDown"));
const ArrowDropUp_1 = tslib_1.__importDefault(require("@mui/icons-material/ArrowDropUp"));
const Business_1 = tslib_1.__importDefault(require("@mui/icons-material/Business"));
const Close_1 = tslib_1.__importDefault(require("@mui/icons-material/Close"));
const Dashboard_1 = tslib_1.__importDefault(require("@mui/icons-material/Dashboard"));
const Dns_1 = tslib_1.__importDefault(require("@mui/icons-material/Dns"));
const ExpandLess_1 = tslib_1.__importDefault(require("@mui/icons-material/ExpandLess"));
const ExpandMore_1 = tslib_1.__importDefault(require("@mui/icons-material/ExpandMore"));
const FilterAlt_1 = tslib_1.__importDefault(require("@mui/icons-material/FilterAlt"));
const FolderShared_1 = tslib_1.__importDefault(require("@mui/icons-material/FolderShared"));
const KeyboardDoubleArrowLeft_1 = tslib_1.__importDefault(require("@mui/icons-material/KeyboardDoubleArrowLeft"));
const KeyboardDoubleArrowRight_1 = tslib_1.__importDefault(require("@mui/icons-material/KeyboardDoubleArrowRight"));
const ListAlt_1 = tslib_1.__importDefault(require("@mui/icons-material/ListAlt"));
const ManageSearch_1 = tslib_1.__importDefault(require("@mui/icons-material/ManageSearch"));
const People_1 = tslib_1.__importDefault(require("@mui/icons-material/People"));
const Rule_1 = tslib_1.__importDefault(require("@mui/icons-material/Rule"));
const ScreenSearchDesktop_1 = tslib_1.__importDefault(require("@mui/icons-material/ScreenSearchDesktop"));
const Sensors_1 = tslib_1.__importDefault(require("@mui/icons-material/Sensors"));
const SettingsInputComposite_1 = tslib_1.__importDefault(require("@mui/icons-material/SettingsInputComposite"));
const Share_1 = tslib_1.__importDefault(require("@mui/icons-material/Share"));
const TravelExplore_1 = tslib_1.__importDefault(require("@mui/icons-material/TravelExplore"));
const icons_1 = require("../icons");
// Some default styling
exports.sx = {
    color: "primary.contrastText",
    height: "1.2em",
    width: "1.2em",
};
const IconComponent = ({ iconId, logger, ...rest }) => {
    switch (iconId) {
        case "act":
            return react_1.default.createElement(Share_1.default, { "aria-hidden": true, ...rest });
        case "adminSettings":
            return react_1.default.createElement(icons_1.MenuAdminMenuIcon, { "aria-label": "admin", ...{ sx: exports.sx, ...rest } });
        case "alarm":
            return react_1.default.createElement(Rule_1.default, { "aria-hidden": true, ...rest });
        case "apiDocs":
            return react_1.default.createElement(icons_1.MenuDocsIcon, { "aria-label": "admin", ...{ sx: exports.sx, ...rest } });
        case "asset":
            return react_1.default.createElement(AccountBalance_1.default, { "aria-hidden": true, ...rest });
        case "case":
            return react_1.default.createElement(icons_1.MenuCaseIcon, { "aria-label": "case", ...{ sx: exports.sx, ...rest } });
        case "caseBeta":
            return react_1.default.createElement(icons_1.MenuCaseIcon, { ...{ ...rest } });
        case "chat":
            return react_1.default.createElement(icons_1.MenuNFCertChat, { "aria-hidden": true, ...rest });
        case "close":
            return react_1.default.createElement(Close_1.default, { "aria-hidden": true, ...{ sx: exports.sx, ...rest } });
        case "component":
            return react_1.default.createElement(SettingsInputComposite_1.default, { "aria-hidden": true, ...rest });
        case "contact":
            return react_1.default.createElement(icons_1.MenuContactUsIcon, { "aria-label": "admin", ...{ sx: exports.sx, ...rest } });
        case "createCase":
            return react_1.default.createElement(icons_1.MenuCreateCaseIcon, { "aria-label": "create case", ...{ sx: exports.sx, ...rest } });
        case "customer":
            return react_1.default.createElement(Business_1.default, { "aria-hidden": true, ...rest });
        case "dashboard":
            return react_1.default.createElement(Dashboard_1.default, { "aria-hidden": true, ...rest });
        case "data":
            return react_1.default.createElement(icons_1.MenuDataIcon, { "aria-label": "data", ...{ sx: exports.sx, ...rest } });
        case "document":
            return react_1.default.createElement(FolderShared_1.default, { "aria-hidden": true, ...rest });
        case "dropdown-down":
            return react_1.default.createElement(ArrowDropDown_1.default, { "aria-hidden": true, ...{ sx: exports.sx, ...rest } });
        case "dropdown-up":
            return react_1.default.createElement(ArrowDropUp_1.default, { "aria-hidden": true, ...{ sx: exports.sx, ...rest } });
        case "event":
            return react_1.default.createElement(FilterAlt_1.default, { "aria-hidden": true, ...rest });
        case "eventSearch":
            return react_1.default.createElement(ManageSearch_1.default, { "aria-hidden": true, ...rest });
        case "expandLess":
            return react_1.default.createElement(ExpandLess_1.default, { ...rest });
        case "expandMore":
            return react_1.default.createElement(ExpandMore_1.default, { ...rest });
        case "externalApp":
            return react_1.default.createElement(icons_1.MenuExternalApp, { "aria-label": "admin", ...{ sx: exports.sx, ...rest } });
        case "externalAppBeta":
            return react_1.default.createElement(icons_1.MenuExternalApp, { ...rest });
        case "logout":
            return react_1.default.createElement(icons_1.MenuLogoutIcon, { "aria-label": "admin", ...{ sx: exports.sx, ...rest } });
        case "menuClosed":
            return react_1.default.createElement(KeyboardDoubleArrowLeft_1.default, { ...rest });
        case "menuOpen":
            return react_1.default.createElement(KeyboardDoubleArrowRight_1.default, { ...rest });
        case "nfcWiki":
            return react_1.default.createElement(icons_1.MenuNFCertWikiIcon, { "aria-label": "wiki", ...{ sx: exports.sx, ...rest } });
        case "pdns":
            return react_1.default.createElement(Dns_1.default, { "aria-hidden": true, ...rest });
        case "realtime":
            return react_1.default.createElement(icons_1.MenuRealtimeIcon, { "aria-label": "realtime", ...{ sx: exports.sx, ...rest } });
        case "realtimeBeta":
            return react_1.default.createElement(ListAlt_1.default, { "aria-label": "user menu", ...rest });
        case "report":
            return react_1.default.createElement(icons_1.MenuReportsIcon, { "aria-label": "reports", ...{ sx: exports.sx, ...rest } });
        case "reputation":
            return react_1.default.createElement(TravelExplore_1.default, { "aria-hidden": true, ...rest });
        case "reputationSearch":
            return react_1.default.createElement(TravelExplore_1.default, { "aria-hidden": true, ...rest });
        case "sample":
            return react_1.default.createElement(ScreenSearchDesktop_1.default, { "aria-hidden": true, ...rest });
        case "search":
            return react_1.default.createElement(icons_1.MenuSearchIcon, { "aria-label": "search", ...{ sx: exports.sx, ...rest } });
        case "sensor":
            return react_1.default.createElement(Sensors_1.default, { "aria-hidden": true, ...rest });
        case "user":
            return react_1.default.createElement(People_1.default, { "aria-hidden": true, ...rest });
        case "userMenu":
            return react_1.default.createElement(icons_1.MenuUserPrefsIcon, { "aria-label": "user menu", ...{ sx: exports.sx, ...rest } });
        case "none":
            return null;
        default:
            logger && logger.logError('Icon with id "' + iconId + '" not supported in ArgusMenu');
            return null;
    }
};
exports.default = IconComponent;
